import { render, staticRenderFns } from "./EntryEditor.vue?vue&type=template&id=4b87c65e&"
import script from "./EntryEditor.vue?vue&type=script&lang=ts&"
export * from "./EntryEditor.vue?vue&type=script&lang=ts&"
import style0 from "./EntryEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports